module.exports = __webpack_public_path__ + "img/about-problem1.9c27f224.png";